<template>
  <div>
    <el-dialog
      class="dialog-treaty"
      :visible="visible"
      append-to-body
      @close="onConfirm"
      width="560px"
    >
      <div class="content">
        <div class="title">考试记录</div>
        <div class="test-record">
          <div
            class="test-record-info"
            v-for="item in recordList"
            :key="item.id"
          >
            <div style="width: 220px">
              <label style="color: #999">交卷时间：</label>
              <span>{{ item.date }}</span>
            </div>
            <div style="width: 220px">
              <label style="color: #999">作答时长：</label>
              <span>{{ item.dateLength }}</span>
            </div>
            <div class="record-link" @click="seeReport(item.id)">
              查看报告 >
            </div>
          </div>
        </div>
      </div>
      <template v-slot:footer>
        <el-button type="default" @click="onConfirm">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "TestRecordModal",
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    recordList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  watch: {
    showModal(value) {
      this.visible = value;
    },
  },
  methods: {
    onConfirm() {
      this.visible = false;
      this.$emit("update:showModal", false);
    },
    seeReport(id) {
      this.$emit("seeReport", id);
      this.onConfirm();
    },
  },
};
</script>

<style scoped lang="scss">
.dialog-treaty {
  /deep/ .el-dialog__header {
    display: none;
  }
  /deep/ .el-dialog__body {
    padding: 16px 24px 0 24px;
  }
  .content {
    .title {
      font-size: 18px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      color: #333333;
      height: 24px;
      line-height: 24px;
      margin-bottom: 16px;
    }
    .test-record {
      max-height: 320px;
      overflow-y: auto;
      &::-webkit-scrollbar {
        width: 0 !important;
      }
      & {
        -ms-overflow-style: none;
      }
      & {
        overflow: -moz-scrollbars-none;
      }
    }
    .test-record-info {
      display: flex;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      height: 30px;
      color: #333;
      line-height: 30px;
      padding-bottom: 12px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      margin-bottom: 12px;
      .record-link {
        color: $primary-color;
        cursor: pointer;
      }
      .record-link:hover {
        color: $primary-color-hover;
        cursor: pointer;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  /deep/ .el-dialog__footer {
    padding: 23px 24px 24px 24px;
  }
}
</style>
